import styled from 'styled-components';

export const Wrapper = styled.nav``;
export const List = styled.ul`
  margin: 0 0 2rem 0;

  > li {
    display: inline-block;
    padding: 1rem 1rem 1rem 0;

    &::after {
      content: '•';
      margin-left: 1rem;
    }

    &:last-child::after {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/JamstackNav/JamstackNavStyles.js